export interface Report {
  id: string | null;
  name: string;
}

export interface ReportRow {
  id: string;
  name: string;
  description: string;
}

export interface ReportSearchFormValues {
  search: string | null;
}

export interface ReportEditFormValues {
  id?: string | null;
  name: string | null;
}


export interface ReportC02ConsumptionEditFormValues {
  vehicleManufacturerId: string | null;
  vehicleModelId: string | null;
}

export enum ReportCode {
  ReportC02Consumption = "C02-consumption",
}
